<template>
  <section style="width: 100%">
    <el-menu :default-active="path" router class="el-menu-vertical-demo"
             :mode="menu.mode|defaultVal"
             :background-color="menu.backgroundColor"
             :text-color="menu.fontColor"
             :active-text-color="menu.activeColor">
      <el-menu-item id="item" v-for="tab in tabData" :index="tab.path" :style="style" :key="tab.id">
        <ele-icon :componentData="tab.iconParam"/>
        <span>{{tab.name}}</span>
      </el-menu-item>
    </el-menu>
  </section>
</template>
<script>
  import eleIcon from "./eleIcon";

  export default {
    name: "eleMenu", components: {eleIcon},
    filters: {
      defaultVal(val) {
        if (!val) {
          return "horizontal";
        }
      }
    },
    props: {
      componentData: {
        type: String,
      },
      tabs: {
        type: Array
      }
    },
    data() {
      return {
        menu: {},
        style: '',
        path: this.$route.path,
        tabData: this.tabs,
      }
    },
    created() {
      if (this.componentData) {
        let componentData = JSON.parse(this.componentData);
        if (componentData.backGroundColor) {
          this.menu.backGroundColor = componentData.backGroundColor;
        }
        if (componentData.fontColor) {
          this.menu.fontColor = componentData.fontColor;
        }
        if (componentData.activeColor) {
          this.menu.activeColor = componentData.activeColor;
        }
        this.style = 'font-size: ' + componentData.fontSize + ';font-family: '
          + componentData.family;
      }
    },
  }
</script>

<style scoped>
  .el-menu-item:hover {
    background-color: #b0ffaf !important;
    outline: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleMenu.vue